import type { FC, PropsWithChildren } from "react";
import { Navigate, useParams } from "react-router-dom";

import { ROUTES } from "@/app/router";
import { EmbeddablesUserContext } from "@/features/embeddables/context";
import { LogoLoader } from "@/shared/components";
import { useUserValidation } from "./hooks";

export const RequireValidUserCode: FC<PropsWithChildren> = ({ children }) => {
  const { userCode } = useParams();

  const { data, isError, isSuccess, isLoading } = useUserValidation(userCode);

  if (isLoading) {
    return <LogoLoader fullscreen variant="secondary" />;
  }

  if (!userCode || isError || (isSuccess && !data.isValid)) {
    return <Navigate replace to={ROUTES.LOGIN} />;
  }

  return (
    isSuccess && (
      <EmbeddablesUserContext.Provider value={data}>
        {children}
      </EmbeddablesUserContext.Provider>
    )
  );
};
